import Background from '../../Assets/Logo/Background.jpg';
import { Typography } from "@mui/material";

const NoAccessPage = () => {
  return (
    <div style={{ backgroundImage: `url(${Background})`, height: '100%', display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Typography fontWeight={"bold"} fontSize = {"1.2vw"}>
        Your subscription has been expired. Please renew to continue accessing all features.
      </Typography>
    </div>
  )
}

export default NoAccessPage